import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { ContractConcept } from '../../../models/Entities/Contracts/ContractConcept';

export default function ContractConceptsReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    // Concepts by contract (CRUD and bulk)
    // Both flags are flipped by dedicated endpoints that return only a status, so
    // the concept is patched in place rather than replaced with a server payload.
    case 'CONTRACTCONCEPT_SET_ENABLED_RECEIVE_ACTION':
    case 'CONTRACTCONCEPT_SET_APPROVED_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (!CurrentContract) {
        return currentState;
      }

      const FlagAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
      if (!FlagAddendum) {
        return currentState;
      }

      const FlagConcept = FlagAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConceptId);
      if (!FlagConcept) {
        return currentState;
      }

      const PatchedConcept = a.type === 'CONTRACTCONCEPT_SET_ENABLED_RECEIVE_ACTION'
        ? { ...FlagConcept, contractConceptEnabled: a.enabled } as ContractConcept
        : { ...FlagConcept, contractConceptApproved: a.approved } as ContractConcept;

      const PatchedAddendum = {
        ...FlagAddendum,
        concepts: [...(FlagAddendum.concepts || []).filter((item: ContractConcept) => item.id !== a.contractConceptId), PatchedConcept],
      } as ContractAddendum;

      const PatchedContract = {
        ...CurrentContract,
        addendums: [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== PatchedAddendum.id), PatchedAddendum],
      } as Contract;

      return {
        ...currentState,
        list: [...(currentState.list || []).filter((item: Contract) => item.id !== PatchedContract.id), PatchedContract],
      };
    }
    case 'CONTRACTCONCEPT_ADD_RECEIVE_ACTION': {

      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractConcept.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractConcept.contractAddendumId);
        if (CurrentAddendum) {
          const updatedConcepts = [...(CurrentAddendum.concepts || []), a.contractConcept];
          
          const UpdatedAddendum = {
            ...CurrentAddendum,
            concepts: updatedConcepts,
          } as ContractAddendum;
          
          const updatedAddendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== UpdatedAddendum.id), UpdatedAddendum];
          
          const UpdatedContract = {
            ...CurrentContract,
            addendums: updatedAddendums,
          } as Contract;
          
          return {
            ...currentState,
            list: [...(currentState.list || []).filter((item: Contract) => item.id !== UpdatedContract.id), UpdatedContract],
          };
        }
      }
      return currentState;
    }
    case 'CONTRACTCONCEPT_UPDATE_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractConcept.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractConcept.contractAddendumId);
        if (CurrentAddendum) {
          const CurrentConcept = CurrentAddendum.concepts?.find((item: ContractConcept) => item.id === a.contractConcept.id);
          
          const UpdatedConcept: ContractConcept = CurrentConcept
            ? {
                ...a.contractConcept,
                concept: a.contractConcept.concept,
                paymentSchedule: CurrentConcept.paymentSchedule,
                concepts: CurrentConcept.concepts                
              } as ContractConcept
            : a.contractConcept;
          
          const updatedConcepts = CurrentConcept
            ? [...(CurrentAddendum.concepts || []).filter((concept: ContractConcept) => concept.id !== UpdatedConcept.id), UpdatedConcept]
            : [...(CurrentAddendum.concepts || []), UpdatedConcept];
          
          const UpdatedAddendum = {
            ...CurrentAddendum,
            concepts: updatedConcepts,
          } as ContractAddendum;
          
          const updatedAddendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== UpdatedAddendum.id), UpdatedAddendum];
          
          const UpdatedContract = {
            ...CurrentContract,
            addendums: updatedAddendums,
          } as Contract;
          
          return {
            ...currentState,
            list: [...(currentState.list || []).filter((item: Contract) => item.id !== UpdatedContract.id), UpdatedContract],
          };
        }
      }
      return currentState;
    }
    case 'CONTRACTCONCEPT_DELETE_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          const updatedConcepts = (CurrentAddendum.concepts || []).filter((item: ContractConcept) => item.id !== a.contractConceptId);
          
          const UpdatedAddendum = {
            ...CurrentAddendum,
            concepts: updatedConcepts,
          } as ContractAddendum;
          
          const updatedAddendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== UpdatedAddendum.id), UpdatedAddendum];
          
          const UpdatedContract = {
            ...CurrentContract,
            addendums: updatedAddendums,
          } as Contract;
          
          return {
            ...currentState,
            list: [...(currentState.list || []).filter((item: Contract) => item.id !== UpdatedContract.id), UpdatedContract],
          };
        }
      }
      return currentState;
    }
    case 'CONTRACTCONCEPT_GET_ALL_BY_CONTRACTID_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), { ...contract, concepts: a.contractConcepts as ContractConcept[] }] : currentState.list,
      };
    }
    case 'CONTRACTCONCEPT_UPDATE_ALL_BY_CONTRACTID_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), { ...contract, concepts: a.contractConcepts as ContractConcept[] }] : currentState.list,
      };
    }

    // Concepts by addendum (flags + set)
    case 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractConcepts: true,
            isGettingContractConceptsSuccess: false,
            FailGettingContractConcepts: false,
            ErrorGettingContractConcepts: undefined,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractConcepts: false,
            isGettingContractConceptsSuccess: true,
            FailGettingContractConcepts: false,
            ErrorGettingContractConcepts: undefined,
            concepts: a.contractConcepts as ContractConcept[],
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_FAIL_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        let CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.addendumId);
        if (CurrentAddendum) {
          CurrentAddendum = {
            ...CurrentAddendum,
            isGettingContractConcepts: false,
            isGettingContractConceptsSuccess: false,
            FailGettingContractConcepts: true,
            ErrorGettingContractConcepts: a.error,
          } as ContractAddendum;
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((item: ContractAddendum) => item.id !== a.addendumId), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }

    default:
      return currentState;
  }
}
